// extracted by mini-css-extract-plugin
export default {"resetButtonWrap":"resetButtonWrap---pwa1K","resetButton":"resetButton---mYXPR"};